import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Member, Resource, ResourceCard } from 'src/app/core/models/project-pilot.model';
import { Context } from 'src/app/shared/models/context';
import { PrivilegeType } from 'src/app/shared/models/domain';
import { AuthService } from 'src/app/shared/services/auth.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { DataService } from 'src/app/shared/services/data.service';
import { ProjectPilotService } from 'src/app/shared/services/project-pilot.service';

@Component({
  selector: 'app-resource-insight',
  templateUrl: './resource-insight.component.html',
  styleUrls: ['./resource-insight.component.scss']
})
export class ResourceInsightComponent implements OnInit {
 public resource: Member[] = [];
  public isLoading: boolean = true;
  public count = 3;
  public employeeCount!: number;
  public ResourceCard: ResourceCard;
  public privilege: PrivilegeType;
  public context: Context;


  constructor(
    private projectPilotService: ProjectPilotService,
    private commonService: CommonService,
    private authService: AuthService,
    private dataService: DataService

  ) { }

  ngOnInit(): void {
    this.dataService.privilege().subscribe(privilege => { this.privilege = this.commonService.getPrivileges(privilege) });
    this.context = this.authService.getContextData();
    if (this.context && this.context?.employeeId) {
      this.getResourceCard();
    }
    this.getResourceInsights();
  }

  public getResourceInsights() {
    this.projectPilotService.getResourceInsights(this.context.teamId,this.count).subscribe({
      next: (resource: Member[]) => {
        this.resource = resource;
        this.isLoading = false;
      }, 
      error: (error: HttpErrorResponse) => { 
        this.commonService.setToastr(500, error?.error?.name || error.error);
        this.isLoading = false;
      }
    });
  }

  public getResourceCard() {
    this.projectPilotService.getResourceCard(this.context.employeeId).subscribe({
      next: (resource: ResourceCard) => {
        this.ResourceCard = resource;
        this.isLoading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.commonService.setToastr(500, error?.error?.name || error.error);
        this.isLoading = false;
      }
    });
  }
}
